import React, { useState } from 'react';
import HeaderQuoteDetailStyle from './style';
import { Button, Flex, Spin, Switch } from 'antd';
import useQueryApi from 'src/hooks/useApiQuery';
import { useSelector, useDispatch } from 'react-redux';
import { quoteDetailSelector } from 'src/redux/selectors/quoteDetailSelector';
import { toggleEditQuote } from 'src/redux/actions/toggleEditQuoteAction';
import { toggleEditQuoteSelector } from 'src/redux/selectors/toggleEditQuoteSelector';
import { paramsQuoteDetailSelector } from 'src/redux/selectors/paramsQuoteDetailSelector';
import images from 'src/assets/image';
import isEmpty from 'lodash/isEmpty';
import { checkChangeApi, checkMultipleChangeApi } from 'src/api/apiCheckChange';
import ModalComponent from 'src/components/modalCustom';
import ModalConfirmVersion from 'src/components/modalConfirmVersion';
import ModalConfirmSaveQuote from 'src/components/modalConfirmSaveQuote';
import {
    setParamsQuoteDetail,
    updateParamsQuoteDetail,
} from 'src/redux/actions/paramsQuoteDetailAction';
import { useLocation } from 'react-router-dom';
import useIsMobile from 'src/hooks/useIsMobile';
import MainImageComponent from 'src/components/mainImageComponent';
import useIsPdfPage from 'src/hooks/useIsPdfPage';
import TitleMultipleQuotesComponent from 'src/components/titleMultipleQuotes';
import { multipleQuotesSelector } from 'src/redux/selectors/multipleQuotesSelector';
import { updateMultipleQuotesAction } from 'src/redux/actions/multipleQuotesAction';
import { areFieldsEmpty, isPaymentScheduleValid } from 'src/utils/valid';
import Banner from './banner';

interface HeaderQuoteDetailProps {
    isPreview: boolean;
}

const HeaderQuoteDetail: React.FC<HeaderQuoteDetailProps> = ({ isPreview }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingGenerate, setIsLoadingGenerate] = useState(false);
    const [isLoadingSend, setIsLoadingSend] = useState(false);
    const [isVersionChange, setIsVersionChange] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalSaveVisible, setIsModalSaveVisible] = useState(false);
    const [typeModal, setTypeModal] = useState<string>('');
    const dispatch = useDispatch();
    const location = useLocation();
    const isPdfPage = useIsPdfPage();
    const isViewPreview = isPreview && !isPdfPage;

    const {
        id = '',
        isSafariTemplate = false,
        isEvent,
        safariLink,
        paymentSchedule,
    } = useSelector(quoteDetailSelector);
    const isEdit = useSelector(toggleEditQuoteSelector);
    const params = useSelector(paramsQuoteDetailSelector);
    const isMobile: boolean = useIsMobile();

    const { ids: quotesArray = [] } = useSelector(multipleQuotesSelector);
    const isMultipleQuotes = quotesArray.length > 1;

    const isAllSafariTemplate = params?.isSafariTemplate ?? isSafariTemplate;

    const allSafariLink = params?.safariLink ?? safariLink;
    const allPaymentSchedule = params?.paymentSchedule ?? paymentSchedule;

    const isCheckNoSave = () => {
        return (
            isEmpty(params) ||
            params?.title === '' ||
            (!isAllSafariTemplate &&
                params?.priceGroups &&
                areFieldsEmpty(params?.priceGroups)) ||
            (isAllSafariTemplate &&
                (!allSafariLink ||
                    (allPaymentSchedule &&
                        !isPaymentScheduleValid(allPaymentSchedule || []))))
        );
    };

    const { refetch } = useQueryApi(
        ['idCheck'],
        () =>
            isMultipleQuotes
                ? checkMultipleChangeApi(`?quoteRefs=${quotesArray.join(',')}`)
                : checkChangeApi(id),
        {
            enabled: false,
        },
    );

    const handleToggleEdit = () => {
        dispatch(toggleEditQuote(isEdit));
        dispatch(setParamsQuoteDetail({}));
    };

    const handleRefetch = async (type: string) => {
        try {
            setIsLoading(true);
            const { data: versionChange }: any = await refetch();
            setTypeModal(type);
            if (!versionChange?.changed) {
                dispatch(
                    updateMultipleQuotesAction({
                        versionId: versionChange?.versionId,
                    }),
                );
            }
            setIsVersionChange(versionChange?.changed || false);
            setIsModalVisible(true);
            setIsLoadingGenerate(false);
            setIsLoadingSend(false);
            setIsLoading(false);
        } catch {
            setIsLoadingGenerate(false);
            setIsLoadingSend(false);
            setIsLoading(false);
        }
    };

    const handleSave = () => {
        setIsModalSaveVisible(true);
    };

    const handleCloseModalSave = () => {
        setIsModalSaveVisible(false);
    };

    const handleGenerateLink = () => {
        setIsLoadingGenerate(true);
        handleRefetch('GenLink');
    };

    const handleSendMail = () => {
        setIsLoadingSend(true);
        handleRefetch('SendMail');
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
        setTypeModal('');
    };

    const handleSwitchTemplate = (checked: boolean) => {
        dispatch(
            updateParamsQuoteDetail({
                isSafariTemplate: checked,
            }),
        );
    };

    const renderBtnBoxEdit = () => (
        <>
            {isEvent && (
                <Flex align="center" gap={5}>
                    <Switch
                        defaultValue={isSafariTemplate}
                        onChange={handleSwitchTemplate}
                    />
                    <span>Switch to Safari Template</span>
                </Flex>
            )}

            <Button
                type="primary"
                className=""
                onClick={handleToggleEdit}
                ghost
            >
                Reset Changes
            </Button>
            <Button
                type="primary"
                className=""
                onClick={handleSave}
                ghost
                disabled={isCheckNoSave()}
            >
                Save
            </Button>
        </>
    );

    const renderBtnBoxPreview = () => (
        <>
            <Button
                type="primary"
                className=""
                onClick={handleToggleEdit}
                ghost
                disabled={isLoading}
            >
                Edit
            </Button>
            <Spin spinning={isLoadingGenerate}>
                <Button
                    type="primary"
                    className=""
                    onClick={handleGenerateLink}
                    disabled={isLoading && !isLoadingGenerate}
                >
                    Generate link
                </Button>
            </Spin>
            <Spin spinning={isLoadingSend}>
                <Button
                    type="primary"
                    className=""
                    onClick={handleSendMail}
                    disabled={isLoading && !isLoadingSend}
                >
                    Send
                </Button>
            </Spin>
        </>
    );

    const renderPreview = () => (
        <div className="box-preview">
            <div className="container-ydp">
                <Flex
                    align="center"
                    justify={isMobile ? 'end' : 'space-between'}
                    gap={32}
                >
                    <div className="role">
                        You're viewing quote in{' '}
                        <strong>{isEdit ? 'Edit' : 'Preview'} mode</strong>
                    </div>
                    <Flex align="center" gap={16}>
                        {isEdit ? renderBtnBoxEdit() : renderBtnBoxPreview()}
                    </Flex>
                </Flex>
            </div>
        </div>
    );

    const renderHeader = () => (
        <div className="box-header">
            <div className="container-ydp">
                <Flex align="center" justify="space-between">
                    <div className="logo">
                        <img alt="logo" src={images.logoYGT} />
                    </div>
                    <div className="ref">Quote Ref: {id}</div>
                </Flex>
            </div>
        </div>
    );

    const renderModalCheckVersionChange = () => (
        <ModalComponent
            width={500}
            visible={isModalVisible}
            onClose={handleCloseModal}
            title={
                !isVersionChange && typeModal === 'GenLink'
                    ? 'Share your quote with your fellow golfers'
                    : 'Confirmation'
            }
            content={
                <ModalConfirmVersion
                    onClose={handleCloseModal}
                    typeModal={typeModal}
                    isVersionChange={isVersionChange}
                />
            }
        />
    );

    return (
        <HeaderQuoteDetailStyle className={isViewPreview ? 'preview' : ''}>
            {isViewPreview && renderPreview()}
            {renderHeader()}
            <TitleMultipleQuotesComponent />
            <Banner />

            {isMobile && !location.pathname.includes('itineraryInDetail') && (
                <div className="container-ydp">
                    <MainImageComponent />
                </div>
            )}
            {renderModalCheckVersionChange()}
            <ModalConfirmSaveQuote
                onClose={handleCloseModalSave}
                isVisible={isModalSaveVisible}
            />
        </HeaderQuoteDetailStyle>
    );
};

export default HeaderQuoteDetail;
